class BrowserServicesSingleton {
  constructor() {
    if (!BrowserServicesSingleton.instance) {
      this.isLoading = true;
      this.isError = false;
      BrowserServicesSingleton.instance = this;
    }
    return BrowserServicesSingleton.instance;
  }

  setLoading(loading) {
    this.isLoading = loading;
  }

  getLoading() {
    return this.isLoading;
  }

  setIsError(isError) {
    this.isError = isError;
  }

  getIsError() {
    return this.isError;
  }
}

const browserServicesSingleton = new BrowserServicesSingleton();

export default browserServicesSingleton;
